(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-grid"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    if($(window).width() < 700){
      $('.logo-grid').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
